/**
 * Auth Api
 * Auth Xpo Api which handles all the api restful calls
 *
 * OpenAPI spec version: v3.0.1.0
 * Contact: ea@xpo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { SearchRequest } from '../model/searchRequest';
import { Service } from '../model/service';
import { ServiceRequest } from '../model/serviceRequest';
import { ServiceSearchResults } from '../model/serviceSearchResults';
import { ValidationResult } from '../model/validationResult';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ServicesService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Services - List
     * This gets all the Services PageSize default to 50                Sample request:                GET /services
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public servicesGet(observe?: 'body', reportProgress?: boolean): Observable<Array<Service>>;
    public servicesGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Service>>>;
    public servicesGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Service>>>;
    public servicesGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;
        const pageSize = 200;
        const page = 1
        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

      return this.httpClient.get<Array<Service>>(`${this.configuration.basePath}/Services/page/${page}/size/${pageSize}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Services - Create
     * This creates the Service, and returns the service                Sample request:                POST /services                {                   \&quot;ClientId\&quot;:\&quot;sample-service\&quot;,                   \&quot;Name\&quot;:\&quot;sample service\&quot;,                   \&quot;Description\&quot;:null                }
     * @param serviceRequest
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public servicesPost(serviceRequest?: ServiceRequest, observe?: 'body', reportProgress?: boolean): Observable<Service>;
    public servicesPost(serviceRequest?: ServiceRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Service>>;
    public servicesPost(serviceRequest?: ServiceRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Service>>;
    public servicesPost(serviceRequest?: ServiceRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Service>(`${this.configuration.basePath}/Services`,
            serviceRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Services - Search
     * This is for getting the Services for the grid PageSize default to 50                Sample request:                POST /services/search                {                    \&quot;Q\&quot;: null,                    \&quot;Page\&quot;: \&quot;1\&quot;                }
     * @param searchRequest The search Request.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public servicesSearchPost(searchRequest?: SearchRequest, observe?: 'body', reportProgress?: boolean): Observable<ServiceSearchResults>;
    public servicesSearchPost(searchRequest?: SearchRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceSearchResults>>;
    public servicesSearchPost(searchRequest?: SearchRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceSearchResults>>;
    public servicesSearchPost(searchRequest?: SearchRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ServiceSearchResults>(`${this.configuration.basePath}/Services/search`,
            searchRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Services - Delete
     * Deletes the Service by ServiceId                Sample request:                DELETE /services/{serviceId}
     * @param serviceId The service id.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public servicesServiceIdDelete(serviceId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public servicesServiceIdDelete(serviceId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public servicesServiceIdDelete(serviceId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public servicesServiceIdDelete(serviceId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (serviceId === null || serviceId === undefined) {
            throw new Error('Required parameter serviceId was null or undefined when calling servicesServiceIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.configuration.basePath}/Services/${encodeURIComponent(String(serviceId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Services - By Id
     * This gets the Service by Id                Sample request:                GET /services/{serviceId}
     * @param serviceId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public servicesServiceIdGet(serviceId: string, observe?: 'body', reportProgress?: boolean): Observable<Service>;
    public servicesServiceIdGet(serviceId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Service>>;
    public servicesServiceIdGet(serviceId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Service>>;
    public servicesServiceIdGet(serviceId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (serviceId === null || serviceId === undefined) {
            throw new Error('Required parameter serviceId was null or undefined when calling servicesServiceIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Service>(`${this.configuration.basePath}/Services/${encodeURIComponent(String(serviceId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Services - Update
     * This update the Service, and returns the service                Sample request:                PUT /services/{serviceId}                {                   \&quot;ClientId\&quot;:\&quot;sample-service\&quot;,                   \&quot;Name\&quot;:\&quot;sample service\&quot;,                   \&quot;Description\&quot;:null                }
     * @param serviceId
     * @param serviceRequest
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public servicesServiceIdPut(serviceId: string, serviceRequest?: ServiceRequest, observe?: 'body', reportProgress?: boolean): Observable<Service>;
    public servicesServiceIdPut(serviceId: string, serviceRequest?: ServiceRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Service>>;
    public servicesServiceIdPut(serviceId: string, serviceRequest?: ServiceRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Service>>;
    public servicesServiceIdPut(serviceId: string, serviceRequest?: ServiceRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (serviceId === null || serviceId === undefined) {
            throw new Error('Required parameter serviceId was null or undefined when calling servicesServiceIdPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<Service>(`${this.configuration.basePath}/Services/${encodeURIComponent(String(serviceId))}`,
            serviceRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}



// WEBPACK FOOTER //
// ./src/apiModule/api/services.service.ts